export default __webpack_public_path__ + "media/jesse.e68bf85e.jpg";